import { PlanInterval } from '@aibees/shared/definition';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { CreditInfo } from '@aibees/shared/features/subscription-manager/components/downgrade-confirmation-dialog/components/downgrade-information';
import * as SX from '../sx';

export function useCreditsInformation(): CreditInfo[] {
  const { data } = useCurrentSubscriptionApi();
  const plan = data?.current?.plan;

  return [
    {
      label: `New Plan Credits / ${
        data?.current?.plan?.interval === PlanInterval.MONTH
          ? 'Monthly'
          : 'Yearly'
      }`,
      value: Number(plan?.metadata.request) || 0,
    },
    {
      label: 'New Plan Roll over Credit Cap',
      value: Number(plan?.metadata.rollover) || 0,
    },
    {
      label: 'Balance Pre Upgrade',
      value: Number(data?.credit?.total) - Number(plan?.metadata.request),
    },
    {
      label: 'Balance Post Upgrade',
      value: Number(data?.credit?.total) || 0,
      sx: SX.currentBalance,
    },
  ];
}
